/**
 * TanStack Router: /metas-gestao
 *
 * This route file was auto-generated by the route generation script.
 * Component: MetasGestaoPage
 * Layout: Authenticated (_auth)
 *
 * @see scripts/generate-routes.ts
 * @see docs/architecture/tanstack-router-migration-architecture.md
 */
import { createFileRoute } from '@tanstack/react-router'
import MetasGestaoPage from '@/app/metas-gestao/page'

/**
 * Route: /metas-gestao
 * Layout: _auth (authenticated)
 * Component: MetasGestaoPage
 */
export const Route = createFileRoute('/_auth/metas-gestao')({
  component: MetasGestaoPage,
})
